import reveal from './reveal_controller'
import { CountUp } from 'countup.js';

window.onload = function() {
    var countUp = new CountUp('target', 2000);
    countUp.start();
}

export default class extends reveal {

    static targets = ['number']
    countUp = null

    /**
     * Init countyp
     */
    initialize()
    {
        super.initialize()
        this.countUp = new CountUp(this.numberTarget, parseInt(this.data.get('to')));
    }

    /**
     * Start countup
     */
    afterReveal()
    {
        super.afterReveal()
        this.countUp.start()
    }
}
